import LocationAdministration from "./LocationAdministration";

export default LocationAdministration;
